import * as t from 'io-ts';
import _ from 'lodash';

import {makeApiType} from './apiTypes';

/*
 * Runtime type.
 */

const RSmtpDomain = t.type({
  channelIds: t.readonlyArray(t.number),
  createdAt: t.number,
  dnsProvider: t.string,
  id: t.number,
  isOwner: t.boolean,
  name: t.string,
  updatedAt: t.number,
});

const RDnsValidationResults = t.type({
  channelId: t.number,
  result: t.record(
    t.string,
    t.type({
      name: t.string,
      reason: t.union([t.string, t.undefined]),
      type: t.string,
      value: t.string,
      valid: t.boolean,
    }),
  ),
});

/*
 * Type.
 */

export interface SmtpDomainModel extends t.TypeOf<typeof RSmtpDomain> {}
export interface DnsValidationResultsModel extends t.TypeOf<typeof RDnsValidationResults> {}

/*
 * IO methods.
 */

function parseSmtpDomain(src: any): SmtpDomainModel {
  return {
    channelIds: src.channel_ids,
    createdAt: src.created_at,
    dnsProvider: src.dns_provider,
    id: src.id,
    isOwner: src.is_owner,
    name: src.name,
    updatedAt: src.updated_at,
  };
}

function parseDnsValidationResult(src: any): DnsValidationResultsModel {
  return {
    channelId: src.channel_id,
    result: _.omit(src.result, 'domain', 'valid'),
  };
}

/*
 * API type.
 */

export const ApiSmtpDomains = makeApiType('smtpDomains', t.readonlyArray(RSmtpDomain), (src) =>
  Array.from(src).map(parseSmtpDomain),
);

export const ApiDnsValidationResult = makeApiType(
  'dnsValidationResult',
  RDnsValidationResults,
  parseDnsValidationResult,
);
